import React from 'react';
import { FaLock, FaCheckCircle } from 'react-icons/fa';

const SecurityNotice: React.FC = () => {
    return (
        <section className="w-full px-4 sm:px-6 py-10 md:py-16">
            <div className="max-w-[1280px] mx-auto">
                <div
                    className="relative overflow-hidden rounded-[24px] md:rounded-[40px] p-6 sm:p-8 md:p-12 shadow-2xl border border-[var(--border-light)]/10"
                    style={{
                        background: 'var(--secondary-accent)',
                        color: 'var(--background-gradient-start)'
                    }}
                >
                    {/* Background decoration */}
                    <div className="absolute top-0 right-0 -mr-20 -mt-20 w-60 h-60 md:w-80 md:h-80 bg-[var(--primary)] opacity-[0.05] rounded-full blur-3xl pointer-events-none" />

                    <div className="relative  flex flex-col lg:flex-row gap-8 md:gap-12 items-start">
                        {/* Left Side: Header & Content */}
                        <div className="flex-1 space-y-6 md:space-y-8 w-full">
                            <div className="flex flex-col sm:flex-row sm:items-center gap-4 md:gap-6">
                                <div className="inline-flex p-3.5 md:p-5 bg-white/5 rounded-xl md:rounded-2xl border border-white/10 shadow-inner w-fit">
                                    <FaLock className="text-[var(--primary)] text-xl md:text-3xl" />
                                </div>
                                <div>
                                    <h2 className="text-xl sm:text-2xl md:text-3xl font-black tracking-tight uppercase leading-tight">
                                        Security Notice
                                    </h2>
                                    <p className="text-[10px] md:text-[12px] font-bold text-[var(--text-gray-light)] uppercase tracking-widest opacity-80 mt-1 md:mt-2">
                                        Fraud Awareness • All Domains
                                    </p>
                                </div>
                            </div>

                            <p className="text-base sm:text-lg md:text-xl font-medium leading-relaxed opacity-90 max-w-2xl">
                                <span className="font-black text-[var(--primary)]">Fraudsters</span> are impersonating our employees via phone calls, SMS & social media to collect fraudulent payments.
                                Stay vigilant.
                            </p>

                            <ul className="space-y-3 md:space-y-4">
                                {[
                                    "Do not click unknown links or reply to suspicious messages",
                                    "Verify email IDs and domains before engaging",
                                    "Be cautious of calls claiming to be from us"
                                ].map((item, index) => (
                                    <li key={index} className="flex items-start gap-3 group">
                                        <FaCheckCircle className="text-[var(--success-text)] mt-1 md:mt-1.5 shrink-0 group-hover:scale-110 transition-transform text-sm md:text-base" />
                                        <span className="text-sm sm:text-base font-semibold leading-snug opacity-80 group-hover:opacity-100 transition-opacity">
                                            {item}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Right Side: Safe Payment Box */}
                        <div className="w-full lg:w-[380px] shrink-0">
                            <div
                                className="p-6 sm:p-8 rounded-2xl md:rounded-3xl border border-[var(--primary)]/30 relative overflow-hidden h-full"
                                style={{ background: 'rgba(255, 255, 255, 0.03)' }}
                            >
                                <div className="flex items-center gap-3 mb-4">
                                    <FaLock className="text-[var(--primary)] text-sm md:text-base" />
                                    <h3 className="text-[12px] md:text-sm font-black text-[var(--primary)] uppercase tracking-widest">
                                        Safe Payment
                                    </h3>
                                </div>
                                <p className="text-sm sm:text-base md:text-lg font-bold mb-5 opacity-95 leading-snug">
                                    Pay only through our official website or authorised links.
                                </p>
                                <div className="pt-5 border-t border-white/10">
                                    <p className="text-[13px] md:text-[15px] font-medium leading-relaxed opacity-80 italic" lang="hi">
                                        भुगतान केवल आधिकारिक वेबसाइट से करें। किसी अज्ञात लिंक पर भरोसा न करें।
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SecurityNotice;
